import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=d406e350&scoped=true&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&id=d406e350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d406e350",
  null
  
)

export default component.exports